import { NextPage } from 'next'
import React, { useState, useRef } from 'react'
import { withI18n } from '~/hocs'
import { AppCommonProps } from 'types/app'
import dynamic from 'next/dynamic'
const Picker = dynamic(() => import('emoji-picker-react'), { ssr: false })
import _ from 'lodash'
import { getAvatar } from '~/utils'
import CommentReplyList from './CommentReplyList'
import config from '~/config'
import CommentInformation from './CommentInformation'

const CommentItem: NextPage<AppCommonProps> = ({
  t, item, isLoadingComment, onHandleReply,onHandleUpdate,user,onHandleDelete,onHandleHide,videoUserID, profile,
}: any) => {
  const [isReply, setIsReply] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [showPicker, setShowPicker] = useState(false)
  const [contentReply, setContentReply] = useState("")
  const [contentEdit, setContentEdit] = useState("")
  const [isShowReplyInput, setIsShowReplyInput] = useState(false)
  const [height, setHeight] = useState('');
  const commentItemRef = useRef()
  
  const onEmojiClick = (event: any, emojiObject: { emoji: string }) => {
    setContentEdit(contentEdit + emojiObject.emoji)
  }
  const handleOnChange = (e: any) => {
    setContentEdit(e.target.value)
    const lines = e.target.value.split('\n');
    if (lines[lines.length - 1].match(/^\s*$/) && lines.length > 1) {
      setHeight(`${e.target.scrollHeight - 11}px`)
    } else if (lines.length === 1) {
      setHeight('39px')
    } else {
      setHeight(`${e.target.scrollHeight}px`)
    }
  }
  const handleSubmitReply = () => {
    if (contentReply.length > 0) {
      const replies = {
        content: contentReply,
        parentCommentId: item.id,
        userId: profile?.id,
        creatorId: item.creator_id
      }
      onHandleReply(replies)
      setIsShowReplyInput(false)
      setContentReply("")
    } else {
      alert('コメントを入力してください。');
    }
  }
  const handleEdit = () => {
    if (contentEdit.length > 0) {
      const edits = {
        content: contentEdit,
        id: item.id,
      }
      onHandleUpdate(edits)
      setIsEdit(false)
    }
    else {
      // alert('コメントを入力してください。');
      setIsEdit(false)
    }
  }
  const handleDeleteComment = () => {
    onHandleDelete(item.id)
  }
  const handleHideComment = () => {
    onHandleHide(item.id)
  }
  return (
    <div className="d-flex align-items-center mb-3">
      <img className="mr-2 align-self-start" src={item.avatar && item.avatar.substring(0,8) == "property" ? `${config.assetPrefix}/${item?.avatar}` :getAvatar(item)} alt="avatar" width="50" />
      <div className="flex-1">
        <CommentInformation item={item} setIsEdit={setIsEdit} isEdit={isEdit} setHeight={setHeight} height={height} videoUserID={videoUserID} commentItemRef={commentItemRef}
         handleHideComment={handleHideComment} handleDeleteComment={handleDeleteComment} handleEdit={handleEdit} handleOnChange={handleOnChange} isLoadingComment={isLoadingComment} 
         onEmojiClick={onEmojiClick} showPicker={showPicker} setShowPicker={setShowPicker} profile={profile}/>
        <CommentReplyList item={item} isReply={isReply} setIsReply={setIsReply} contentReply={contentReply} setContentReply={setContentReply}
          handleSubmitReply={handleSubmitReply} handleEdit={handleEdit} onHandleUpdate={onHandleUpdate} onHandleDelete={onHandleDelete} onHandleHide={onHandleHide} user={user} isShowReplyInput={isShowReplyInput} 
          setIsShowReplyInput={setIsShowReplyInput} showPicker={showPicker} setShowPicker={setShowPicker} videoUserID={videoUserID} profile={profile} />
      </div>
    </div>
  )
}


export default withI18n(CommentItem)
